import React from 'react';
import {
    ArrowRight,
} from "../../components/icons";
import styles from './region-table.module.scss';

const TableScroll = () => (
    <div style={{ textAlign: "left", paddingLeft: 20, marginTop: 20 }}>
        <span className={styles.cellInfoText}>Scroll the table to see more</span>
        <ArrowRight fill="blue" width="10px" height="10px" style={{ marginLeft: 10 }} />
    </div>
)

export default TableScroll;


// WEBPACK FOOTER //
// ./src/components/region-table/table-scroll.js